import DomainEntity from '@/models/DomainEntity'

export default class StateOffers extends DomainEntity {
  static get collectionName() {
    return 'stateoffers/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
